import { render, staticRenderFns } from "./SliderActivity.vue?vue&type=template&id=4cf1a55e&scoped=true"
import script from "./SliderActivity.vue?vue&type=script&lang=js"
export * from "./SliderActivity.vue?vue&type=script&lang=js"
import style0 from "./SliderActivity.vue?vue&type=style&index=0&id=4cf1a55e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf1a55e",
  null
  
)

export default component.exports